import type { TemplateDefinition } from "@/api/client";

/** A new template's first draft, for the designer to edit; passes render.ValidatePublishable. */
export const STARTER_DEFINITION: TemplateDefinition = {
  page: { size: "A4", orientation: "landscape", margins_mm: { top: 15, right: 15, bottom: 15, left: 15 } },
  // y is the top of the text line; 98 mm puts a 28 pt line across the page's middle.
  fields: [{ type: "text", bind: "member.full_name", x_mm: 15, y_mm: 98, w_mm: 267, size_pt: 28, align: "center" }],
};
